var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"p-25"},[_c('div',{staticClass:"md:flex justify-between items-center md:space-y-0 space-y-20"},[_c('h2',{staticClass:"h5"},[_vm._v(" "+_vm._s(_vm.$t('health_actions.home.gift_card', [_vm.healthActionTitle]))+": "),_c('span',{staticClass:"text-green-500"},[_vm._v(" "+_vm._s(_vm.currentBalanceText)+" ")])]),_c('HMButton',{attrs:{"to":{
        name: 'rewards-redeem',
        query: { hacId: _vm.healthActionCompletionId },
      }}},[_vm._v(" "+_vm._s(_vm.$t('rewards.landing.redeem_now'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }